import { z } from 'zod';
import {
  unitAliasSchema,
  type CreateUnitAliasInput,
  type UnitAliasDto,
} from '@eombor/contracts';
import { apiClient } from '../../auth/model/auth.store.js';
import type { ApiClient } from '../../../shared/api/client.js';

/**
 * 1C BIRLIGINI MOS KELTIRISH. Manba:
 *   `catalog/infrastructure/http/unit-alias.controller.ts`
 *
 * Alohida sahifasi yo'q va kerak ham emas: bu yerga odam faqat yuklash
 * oynasida, tanilmagan birlik chiqqanda keladi. Sahifa bo'lsa, u yerga
 * oldindan kirib o'tirish kerak bo'lardi — ya'ni muammoni oldindan
 * bilishi shart bo'lardi.
 */
export interface UnitAliasApi {
  list: () => Promise<UnitAliasDto[]>;
  create: (input: CreateUnitAliasInput) => Promise<UnitAliasDto>;
}

export const createUnitAliasApi = (client: ApiClient): UnitAliasApi => ({
  list: () => client.apiFetch('/unit-aliases', { schema: z.array(unitAliasSchema) }),

  create: (input) =>
    client.apiFetch('/unit-aliases', {
      method: 'POST',
      body: JSON.stringify(input),
      schema: unitAliasSchema,
    }),
});

export const unitAliasApi = createUnitAliasApi(apiClient);
